// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue13(props) {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        fill: #5b5b5b;\n      }\n\n      .st1, .st2 {\n        isolation: isolate;\n      }\n\n      .st3, .st4, .st5, .st6 {\n        fill: #fff;\n      }\n\n      .st3, .st5, .st6 {\n        stroke: #fff;\n      }\n\n      .st7, .st2 {\n        fill: #68836a;\n      }\n\n      .st8 {\n        fill: #ffec5f;\n      }\n\n      .st9 {\n        fill: #a88b49;\n      }\n\n      .st10 {\n        fill: #a98c48;\n      }\n\n      .st11 {\n        fill: #7f7f7f;\n      }\n\n      .st2 {\n        font-family: ArialMT, Arial;\n        font-size: 11px;\n      }\n\n      .st5 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n\n      .st6 {\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="TEX_-_13">
                <g id="Compass_copy_8">
                    <g id="Compass">
                        <polygon
                            className="st0"
                            points="232.2 192.24 228.3 200.52 222.54 206.09 225.62 198.68 232.2 192.24"
                        />
                        <path
                            className="st11"
                            d="M235.79,186.73c7.06,4.85,8.86,14.5,4.01,21.57s-14.5,8.86-21.57,4.01c-7.06-4.85-8.86-14.5-4.01-21.57h0c4.85-7.05,14.5-8.84,21.56-4h.01ZM219,211.22c6.46,4.44,15.29,2.8,19.73-3.66s2.8-15.29-3.66-19.73-15.29-2.8-19.73,3.66h0c-4.42,6.47-2.78,15.29,3.67,19.73h0Z"
                        />
                        <circle
                            className="st0"
                            cx={227.02}
                            cy={199.53}
                            r={2.97}
                        />
                        <path
                            className="st0"
                            d="M222.77,207.85l-1.77,2.54-.39-.27v-2.55h0l-1.2,1.75-.41-.32,1.74-2.54.39.27v2.56h0l1.21-1.76.43.32Z"
                        />
                        <circle
                            className="st8"
                            cx={227.01}
                            cy={199.54}
                            r={1.65}
                        />
                    </g>
                </g>
                <path
                    id="Outfield"
                    className="st10"
                    d="M27.36,108.91l.06-14,43.76-52.67,19.38-10.79,67.28-.3,16,13.56h8.52l43.12,47.64-1.48,16.91-16.59,16.92-1.58,2.32s-57.18,84.47-63.13,92c-8.74,11-21.62,12.66-32.25.48-11.45-13.26-59.11-75.56-66.81-87.1l.72-3.37s-17-21.6-17-21.6Z"
                />
                <path
                    id="grass"
                    className="st7"
                    d="M36.58,109.13v-13.23l38.7-48.66,18.44-10.35,58.89-.3,15.33,12.8h6.5l43.75,47.41-2.95,12.94-16.32,17.51-.72,2.41s-54.61,77.46-60.14,84.67-13.71,14.43-21.41,4.09-66.65-86.59-66.65-86.59v-4.57s-13.42-18.13-13.42-18.13Z"
                />
                <g id="infield_sand">
                    <path
                        className="st3"
                        d="M164.34,168.49s-12-31-38.82-30.83c-27.29.18-39.38,30.1-39.38,30.1l32.46,31.15c-1.2,1.06-1.63,3.33-1.63,4.53,0,4.51,3.66,8.17,8.18,8.16,4.51,0,8.16-3.66,8.16-8.16,0-1.41-.38-2.79-1.1-4l32.13-30.95ZM120.75,195.16l-17.67-17.71c1.14-1.37,3.31-3.3,3.31-5.2,0-.92-.17-1.83-.49-2.69l14.58-14.19c1.34.94,2.9,1,4.68,1s3.36,0,4.67-.83l14.54,14.16c-.3.83-.46,1.71-.46,2.6,0,1.88,2.49,3.84,3.61,5.2l-18.18,17.66h-8.59Z"
                    />
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(10.24 88.03)">
                        <tspan x={0} y={0}>
                            332
                        </tspan>
                    </text>
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(48.45 42.27)">
                        <tspan x={0} y={0}>
                            390
                        </tspan>
                    </text>
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(115.3 26.26)">
                        <tspan x={0} y={0}>
                            400
                        </tspan>
                    </text>
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(162.94 31.15)">
                        <tspan x={0} y={0}>
                            407
                        </tspan>
                    </text>
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(198.56 58.23)">
                        <tspan x={0} y={0}>
                            381
                        </tspan>
                    </text>
                </g>
                <g className="st1">
                    <text className="st2" transform="translate(228.67 94.68)">
                        <tspan x={0} y={0}>
                            325
                        </tspan>
                    </text>
                </g>
            </g>
            <g id="Pitchers_mound">
                <circle className="st3" cx={125.25} cy={177.46} r={3.83} />
            </g>
            <g id="Bases_and_chalk_lines-ALL">
                <rect
                    className="st3"
                    x={123.17}
                    y={176.68}
                    width={3.98}
                    height={1.55}
                />
                <rect
                    className="st6"
                    x={98.4}
                    y={174.55}
                    width={3.04}
                    height={3.04}
                    transform="translate(-95.22 122.19) rotate(-44.99)"
                />
                <rect
                    className="st6"
                    x={148.88}
                    y={174.54}
                    width={3.04}
                    height={3.04}
                    transform="translate(-80.44 157.88) rotate(-44.99)"
                />
                <rect
                    className="st5"
                    x={123.65}
                    y={149.33}
                    width={3.04}
                    height={3.04}
                    transform="translate(-70.01 132.73) rotate(-45.01)"
                />
                <polygon
                    className="st3"
                    points="126.7 201.88 125.16 203.41 123.65 201.88 123.65 200.36 126.7 200.36 126.7 201.88"
                />
                <polygon
                    className="st4"
                    points="125.18 204.53 124.65 204 27.36 106.67 27.36 104.55 125.18 202.41 219.49 108.25 224.56 103.47 224.37 105.54 219.49 110.36 125.18 204.53"
                />
            </g>
        </svg>
    )
}
export default Venue13
